import React, { useState } from "react";
import { ShopifyFormSection } from "./style";
import { GlobalContainer } from "../../../Global/layout";
import { Col, Row } from "antd";
import ShopifyCommonForm from "./ShopifyCommonForm";

const ShopifyForm = ({ data, dataTestimonial, dataTrustedBy }: any) => {
  const [showTitle, setShowTitle] = useState(true);
  return (
    <section className="light">
      <ShopifyFormSection>
        <GlobalContainer>
          <Row>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} span={12}>
              <div className="section-title" data-aos="fade-up">
                <Row>
                  <Col>
                    <span>Trusted by</span>
                  </Col>
                </Row>
              </div>
              <div className="trusted__by__widget" data-aos="fade-up">
                <div className="trusted__by__widget_logo">
                  <Row>
                    {dataTrustedBy?.tsOptions?.trustedByLogos?.uploadLogos?.map(
                      (item: any, index: number) => {
                        return (
                          <div
                            key={index}
                            className="trusted__by__widget_logo__contanier"
                          >
                            <div className="trusted__by__widget_logo__contanier_inner">
                              <img src={item.mediaItemUrl} alt={item.altText} />
                            </div>
                          </div>
                        );
                      }
                    )}
                  </Row>
                </div>
              </div>

              <div className="section-title" data-aos="fade-up">
                <Row>
                  <Col>
                    <span>Testimonials</span>
                  </Col>
                </Row>
              </div>
              <div className="testomonial-box" data-aos="fade-up">
                <h2 className="text-center">What our clients have to say.</h2>
                <div className="testimonials-slider">
                  <div className="testomonial-cont">
                    <div className="testomonial-img">
                      <img src={dataTestimonial?.node?.featuredImage?.node?.mediaItemUrl} alt={dataTestimonial?.node?.featuredImage?.node?.altText} />
                    </div>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: dataTestimonial?.node?.content,
                      }}
                    />
                    <h4>
                      <span>
                        {
                          dataTestimonial?.node?.TestimonialsForCaseStudies
                            ?.author
                        }
                      </span>
                    </h4>
                    <span className="testimonialsname">
                      <span>
                        {
                          dataTestimonial?.node?.TestimonialsForCaseStudies
                            ?.jobTitle
                        }
                      </span>
                      <span>
                        @
                        {
                          dataTestimonial?.node?.TestimonialsForCaseStudies
                            ?.company
                        }
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={0} sm={0} md={0} lg={2} xl={2} span={2}></Col>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={10}
              xl={10}
              span={10}
              data-aos="fade-up"
            >
              <div className="section-title">
                <Row>
                  <Col>
                    <span>Get in touch</span>
                  </Col>
                </Row>
              </div>
              <div className="start_a_project">
                {showTitle && <h2>Grow your eCommerce with Us</h2>}
                <ShopifyCommonForm setShowTitle={setShowTitle} />
              </div>
            </Col>
          </Row>
        </GlobalContainer>
      </ShopifyFormSection>
    </section>
  );
};

export default ShopifyForm;
